import { render, staticRenderFns } from "./VTaskLogbook.vue?vue&type=template&id=17573010"
import script from "./VTaskLogbook.vue?vue&type=script&lang=js"
export * from "./VTaskLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports